// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import * as S from './styled';
import { Logo } from 'assets';

const Header = () => {
  return (
    <S.HeaderWrapper>
      <S.LogoWrapper>
        <Logo />
      </S.LogoWrapper>
    </S.HeaderWrapper>
  );
};

export default Header;
